import { ChangeDetectionStrategy, Component } from '@angular/core';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';

export namespace NCmsSection {
    export const componentId = 'section';

    export interface IColumn {
        size: number;
        components: NICmsContentComponent.IData[];
    }

    export interface IComponentData extends NICmsContentComponent.IData {
        maxWidth?: number;
        items?: IColumn[];
        gap: number;
    }
}
const gridSize = 12;

@ICmsComponent<CmsSectionComponent>({
    id: NCmsSection.componentId,
    name: 'Section',
    isAdvanced: true,
    fields: [
        {
            key: 'maxWidth',
            type: NICmsContentField.EFieldType.number,
            title: 'Content Maximum Width',
            description: 'Maximum width of the content in pixels',
            min: 0,
            default: 1920
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'items',
            title: 'Columns',
            itemName: 'Column',
            defaultSize: 1,
            minSize: 1,
            maxSize: gridSize,
            fields: [
                <NICmsContentField.IChoiceField>{
                    type: NICmsContentField.EFieldType.choice,
                    key: 'size',
                    title: 'Size',
                    required: true,
                    options: Array.from(Array(gridSize + 1).keys())
                        .map(i => i)
                        .map(number => {
                            return { key: number, title: `${number}` };
                        }),
                    default: 1
                },
                <NICmsContentField.IComponentsField>{
                    type: NICmsContentField.EFieldType.components,
                    key: 'components',
                    title: 'Components'
                    // default: []
                }
            ],
            default: [
                { size: gridSize / 2, components: [] },
                { size: gridSize / 2, components: [] }
            ]
        },
        <NICmsContentField.INumberField>{
            type: NICmsContentField.EFieldType.number,
            key: 'gap',
            title: 'Grid Gap',
            description: 'The gap between columns in pixels',
            min: 0,
            required: true,
            default: 32
        },
        NICmsContentComponent.backgroundField
    ],
    priority: 50
})
@Component({
    standalone: true,
    imports: [GridModule, ICmsClientModule],
    selector: 'cms-section',
    templateUrl: './cms-section.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsSectionComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsSection.IComponentData;

    outletOptions?: NICmsContentComponent.IOutletOptions;

    protected readonly gridSize = gridSize;
}
